import React from "react";
import { DialogContext } from "./MyContexts";
import { useDialog } from "../hooks/dialog";

export default function DialogProvider(props: { children: React.ReactNode }) {
  const { dialogState, handleDialogOpen, handleDialogClose } = useDialog();

  return (
    <DialogContext.Provider value={{ dialogState, handleDialogOpen, handleDialogClose }}>
      {props.children}
    </DialogContext.Provider>
  );
}
